import { render, staticRenderFns } from "./LeadsNotifications.vue?vue&type=template&id=5f861252&"
import script from "./LeadsNotifications.vue?vue&type=script&lang=js&"
export * from "./LeadsNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports